//routeHelpers.ts

export function companyRoute(company_id: string | undefined, path: string) {
  if (!company_id) return "/";
  return `/company/${company_id}${path.startsWith("/") ? path : "/" + path}`;
}
